import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import { ReactComponent as CenterParcs } from "../../assets/icons/CenterParcs.svg";

type Verify2faProps = {
  code: string;
  setCode: (code: string) => void;
  onSubmit: (e: any) => void;
  t: any;
};

const CenterParcsVerify2fa: React.FC<Verify2faProps> = ({
  code,
  setCode,
  onSubmit,
  t,
}) => {
  return (
    <div
      className="row vh-100 d-flex align-items-center justify-content-center"
      style={{ background: "#b1eda6" }}
    >
      <Container fluid>
        <Row className="justify-content-center">
          <Col xl={5} lg={6} md={7} sm={9} xs={11}>
            <div className="text-center mb-5 pb-5">
              <CenterParcs style={{ maxWidth: "450px", width: "100%" }} />
            </div>

            <div
              className="p-4 p-md-5 shadow-sm"
              style={{
                backgroundColor: "rgba(255, 255, 255, 0.15)",
                borderRadius: "20px",
              }}
            >
              <Form onSubmit={onSubmit}>
                <Form.Group className="mb-4">
                  <Form.Label
                    className="fw-bold mb-2"
                    style={{ color: "#045e51" }}
                    htmlFor="centerparcs-verify2fa-code"
                  >
                    {t("verify2fa:form.code.label")}
                  </Form.Label>
                  <Form.Control
                    type="number"
                    id="centerparcs-verify2fa-code"
                    size="lg"
                    className="border-0 rounded-pill"
                    style={{
                      backgroundColor: "rgba(255, 255, 255, 0.3)",
                      border: "2px solid #045e51",
                      color: "#045e51",
                      textAlign: "center",
                      fontSize: "1.5rem",
                      letterSpacing: "0.5rem",
                    }}
                    value={code}
                    onChange={({ target: { value } }) => setCode(value)}
                  />
                </Form.Group>

                <div className="d-flex justify-content-center">
                  <Button
                    type="submit"
                    className="w-100 rounded-pill py-3 border-0"
                    style={{
                      backgroundColor: "#045e51",
                      color: "#b1eda6",
                      fontSize: "16px",
                      fontWeight: "bold",
                      boxShadow: "none",
                    }}
                    onFocus={(e: React.FocusEvent<HTMLButtonElement>) => {
                      e.currentTarget.style.boxShadow =
                        "0 0 0 0.2rem rgba(4, 94, 81, 0.25)";
                      e.currentTarget.style.outline = "none";
                    }}
                    onBlur={(e: React.FocusEvent<HTMLButtonElement>) => {
                      e.currentTarget.style.boxShadow = "none";
                    }}
                    onMouseEnter={(e: React.MouseEvent<HTMLButtonElement>) => {
                      e.currentTarget.style.backgroundColor = "#034a3d";
                    }}
                    onMouseLeave={(e: React.MouseEvent<HTMLButtonElement>) => {
                      e.currentTarget.style.backgroundColor = "#045e51";
                    }}
                  >
                    {t("verify2fa:button.submit")}
                  </Button>
                </div>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default CenterParcsVerify2fa;
